import { render, staticRenderFns } from "./CoinbaseCustodyExchangeInput.vue?vue&type=template&id=ea870e84&"
import script from "./CoinbaseCustodyExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./CoinbaseCustodyExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports